// FormCheckbox / FormRadio / FormRadioGroup ortak yardımcıları (bootstrap-vue 2.23 form-radio-check davranışı).
let nextId = 0;

export function nextFormCheckId(prefix) {
  nextId += 1;
  return `${prefix}-${nextId}`;
}

// bootstrap-vue looseEqual: ilkel değerler String() ile karşılaştırılır (true ile "true" eşittir).
export function looseEqual(a, b) {
  if (a === b) return true;
  const aIsObject = a !== null && typeof a === 'object';
  const bIsObject = b !== null && typeof b === 'object';
  if (aIsObject && bIsObject) {
    if (Array.isArray(a) !== Array.isArray(b)) return false;
    if (Array.isArray(a)) return a.length === b.length && a.every((item, index) => looseEqual(item, b[index]));
    const aKeys = Object.keys(a);
    const bKeys = Object.keys(b);
    return aKeys.length === bKeys.length && aKeys.every(key => looseEqual(a[key], b[key]));
  }
  if (aIsObject || bIsObject) return false;
  return String(a) === String(b);
}

export function looseIndexOf(array, value) {
  for (let i = 0; i < array.length; i++) {
    if (looseEqual(array[i], value)) return i;
  }
  return -1;
}
